let $ = jQuery;

class Helpers {

  /*
    getParameterByName() returns a string representing a value within the query string
    in our URL.
    key is a string passed in representing the key.
    uri is an optional uri.
  */
  getQueryStringParameterByName(key, uri) {
    if (!uri) {
      uri = window.location.href;
    }

    key = key.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(uri);

    if (!results) {
       return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  /*
    updateQueryStringParameter() returns a string representing a uri.
    uri is the uri to be evaulated, modified and returned.
    key is a string representing the key to modify.
    value is a string to become the new value.
  */
  updateQueryStringParameter(uri, key, value) {
    let regex = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (uri.match(regex)) {
      return uri.replace(regex, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  isAndroid() {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

    return isAndroid;
  }
}

let helpers = new Helpers();

module.exports = helpers;
